class TimelineSection {
  constructor(selector) {
    this.timeline = selector;
    this.progressLine = this.timeline?.querySelector('.js-timeline-section__line-progress');
    this.circles = this.timeline?.querySelectorAll('.js-timeline-section__circle');
    this.middleOfScreen = window.innerHeight / 2;

    if (this.timeline && this.progressLine && this.circles.length) {
      this.init();
    }
  }

  init() {
    window.addEventListener('scroll', () => this.handleScroll());
  }

  handleScroll() {
    const timelineRect = this.timeline.getBoundingClientRect();
    const scrollStart = timelineRect.top - this.middleOfScreen;
    const scrollEnd = timelineRect.bottom - this.middleOfScreen;

    if (scrollStart < 0 && scrollEnd > 0) {
      const progress = Math.min(1, Math.max(0, (this.middleOfScreen - timelineRect.top) / timelineRect.height));
      this.updateProgressLine(progress);
      this.updateCircles(progress);
    } else if (scrollEnd <= 0) {
      this.updateProgressLine(1);
      this.setAllCirclesActive(true);
    } else {
      this.updateProgressLine(0);
      this.setAllCirclesActive(false);
    }
  }

  updateProgressLine(progress) {
    this.progressLine.style.height = `${progress * 100}%`;
  }

  updateCircles(progress) {
    this.circles.forEach(circle => {
      const circleRect = circle.getBoundingClientRect();
      const circleMiddle = circleRect.top + circleRect.height / 2;

      if (circleMiddle <= this.middleOfScreen) {
        circle.classList.add('is-active');
      } else {
        circle.classList.remove('is-active');
      }
    });
  }

  setAllCirclesActive(isActive) {
    this.circles.forEach(circle => {
      circle.classList.toggle('is-active', isActive);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll('.js-timeline-section');

  if (!elements.length) return;

  elements.forEach(element => {
    new TimelineSection(element);
  });
});